import { tnh_option } from "./location";
const TNH_SETUP = {
    title: "Cổng thông tin đất đai tỉnh Cà Mau",
    openMapBoxKey: "pk.eyJ1IjoidGllbmd0aGV0dGhla3kiLCJhIjoiY2wzd2U0eDhvMDk2ZzNqcXR5eHJkZDZoMiJ9.5Bi2kQ6i-nrfS338iwwWhw",
    // GG Tạm 
   googleMapURLDev: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDWHY2-vTILn6LedwXVXw-5_crRhXF0eKI&libraries&region=VI&language=vi&callback=initMap',
    // // GG Thiệt
    googleMapURLProduct: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBBxXWjo6k86fYf4SavzucbnOHBIbzqyEM&libraries&region=VI&language=vi&callback=initMap',
    huyenSelected: {
        key: 706,
        active: true,
        text: 'Huyện Tân Châu',
        searchID: 1706,
    },
    startCoordinate: {
        lat: 9.176274,
        lng: 105.150784
    },
    defaultZoom: 18,
    allDistrict: { key: '1964', text: 'Toàn huyện', searchID: '0', active: true },
    huyenId: 1964,
    tinhId: 96,
    distanceLoad: '200',
    ktt: 105.5,
    dXS: 0.00101036464,
    dYS: -0.00178137015,
    hackMap: false,
    // apiLink: 'http://ilis.camau.gov.vn/ws/api/',
    // apiDebug: 'http://ilis.camau.gov.vn/ws/api/',
    apiLink: 'https://ilis.camau.gov.vn/ws/api/',
    apiDebug: 'https://ilis.camau.gov.vn/ws/api/',
    accessAccount: {},
    accessKey: ['2022'],
    urlMobile: {
        'urlAndroid': 'https://dl.dropboxusercontent.com/s/9x2704h9zc62t3w/app-release.apk?dl=0',
        'urlIos': 'itms-services://vienthongtayninh.vn/?action=download-manifest&url=https://dl.dropboxusercontent.com/s/gnavnxh9uyb67qt/manifest.plist'
    }

};

export default TNH_SETUP;
// test